// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Badge } from "@/components/ui/badge";

const SOURCE_COLORS: Record<string, string> = {
  api: "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-900",
  backoffice:
    "bg-violet-100 text-violet-700 border-violet-200 dark:bg-violet-950 dark:text-violet-300 dark:border-violet-900",
  cronjob: "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900",
  impact: "bg-green-100 text-green-700 border-green-200 dark:bg-green-950 dark:text-green-300 dark:border-green-900",
};

const FALLBACK = "bg-zinc-100 text-zinc-700 border-zinc-200 dark:bg-zinc-900 dark:text-zinc-400 dark:border-zinc-800";

export function ImportSourceBadge({ source }: { source?: string }) {
  const colorClass = (source && SOURCE_COLORS[source]) ?? FALLBACK;
  return (
    <Badge variant="outline" className={`font-normal text-xs ${colorClass}`}>
      {source ?? "—"}
    </Badge>
  );
}
